import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";

import ContactAndSafetyInfo from "../contactAndSafetyInfo";
import { TextAlignProps } from "../contactAndSafetyInfo/types";
import { AuthContext } from "src/context/authContext";

import { HCPUserSubHeaderProps } from "src/types/users";



const AuthSubHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { sub_header } = useContext(AuthContext);
  const { isManufacturer } = useContext(AuthContext);

  return (
    <div className="row pt-2 mb-3">
      {!isManufacturer ?
        <>
          <div className="col-12 col-md-3">
            <p className="mb-0 fw-bold">
              Sales Rep:{' '} {sub_header ? (sub_header as HCPUserSubHeaderProps).Rep : ''}
            </p>
            <p className="mb-0">
              <span>Email:{' '}</span>
              {sub_header ? (
                <a href={`mailto:${(sub_header as HCPUserSubHeaderProps).Email}`}
                  className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline"
                >
                  {(sub_header as HCPUserSubHeaderProps).Email}
                </a>
              ) : ""}
            </p>
          </div>

          <div className="col-12 col-md-3 text-center px-2 py-2">
            <button className="btn btn-primary w-100" onClick={() => navigate(`/rep_visits/new`)}>
              <i className="bi-calendar-week-fill text-light" style={{color: 'white'}}></i> Schedule a Rep
              Visit
            </button>
          </div>
        </>
        :
        <div className="col-12 col-md-6"></div>
      }

      <div className="col-12 col-md-6">
        <ContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END}/>
      </div>
    </div>
  );
};

export default AuthSubHeader;
